import { Sparkles } from 'lucide-react';

export function PlaceholderPage({
  title,
  description,
}: {
  title: string;
  description: string;
}): JSX.Element {
  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow eyebrow-dot mb-2.5">
          <span>ROADMAP</span>
        </div>
        <h1 className="h-display">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-500 dark:text-ink-400">{description}</p>
      </div>

      <div className="relative overflow-hidden rounded-2xl border border-ink-200/70 dark:border-white/10 bg-white dark:bg-ink-900 p-10 text-center shadow-soft">
        <div className="pointer-events-none absolute -top-16 left-1/2 h-40 w-40 -translate-x-1/2 rounded-full bg-brand-200/40 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-16 -left-12 h-40 w-40 rounded-full bg-accent-violet/15 blur-3xl" />
        <div className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-400 to-brand-700 text-white shadow-glow">
          <Sparkles className="h-6 w-6" />
        </div>
        <div className="relative mt-4 font-display text-lg font-semibold text-ink-900 dark:text-ink-50">
          Coming soon
        </div>
        <p className="relative mx-auto mt-1.5 max-w-md text-sm text-ink-500 dark:text-ink-400">
          This module is part of the nlytics platform scope and ships in an upcoming release.
        </p>
      </div>
    </div>
  );
}
